"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var styled_components_1 = __importDefault(require("styled-components"));
var braft_utils_1 = require("braft-utils");
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var FontSize_1 = __importDefault(require("../Components/FontSize"));
var Divider_1 = __importDefault(require("../Components/Divider"));
var Alignment_1 = __importDefault(require("../Components/Alignment"));
var TextColor_1 = __importDefault(require("../Components/TextColor"));
var BackgroundColor_1 = __importDefault(require("../Components/BackgroundColor"));
var InlineStyle_1 = __importDefault(require("../Components/InlineStyle"));
var BlockType_1 = __importDefault(require("../Components/BlockType"));
var ControlBarButton_1 = __importDefault(require("../Components/ControlBarButton"));
var Emoji_1 = __importDefault(require("../Components/Emoji"));
var PopoverWithOverlayClassname = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement(antd_1.Popover, __assign({}, props, { overlayClassName: className })));
};
var StyledPopover = styled_components_1.default(PopoverWithOverlayClassname)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-popover-inner-content {\n    padding: 6px 8px;\n  }\n"], ["\n  .ant-popover-inner-content {\n    padding: 6px 8px;\n  }\n"])));
var LeftContent = function (_a) {
    var editorState = _a.editorState, setEditorState = _a.setEditorState, wide = _a.wide;
    var collapsibleControls = (react_1.default.createElement(antd_1.Row, { gutter: 8, align: "middle" },
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(Alignment_1.default, { editorState: editorState, onAlign: function (alignment) {
                    setEditorState(braft_utils_1.ContentUtils.toggleSelectionAlignment(editorState, alignment));
                } })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(TextColor_1.default, { onColorChange: function (newColor) {
                    setEditorState(braft_utils_1.ContentUtils.toggleSelectionColor(editorState, newColor));
                }, editorState: editorState })),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(BackgroundColor_1.default, { onColorChange: function (newColor) {
                    setEditorState(braft_utils_1.ContentUtils.toggleSelectionBackgroundColor(editorState, newColor));
                }, editorState: editorState })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(InlineStyle_1.default, { editorState: editorState, toggleInlineStyle: function (style) {
                    setEditorState(braft_utils_1.ContentUtils.toggleSelectionInlineStyle(editorState, style));
                } })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(BlockType_1.default, { editorState: editorState, toggleBlock: function (block) {
                    setEditorState(braft_utils_1.ContentUtils.toggleSelectionBlockType(editorState, block));
                } })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(Emoji_1.default, { onEmojiSelect: function (emoji) {
                    return setEditorState(braft_utils_1.ContentUtils.insertText(editorState, emoji));
                } }))));
    return (react_1.default.createElement(antd_1.Row, { gutter: 8, align: "middle" },
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(icons_1.FontSizeOutlined, null)),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(FontSize_1.default, { editorState: editorState, onFontSizeChange: function (fontSize) {
                    setEditorState(braft_utils_1.ContentUtils.toggleSelectionFontSize(editorState, fontSize));
                } })),
        wide && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(antd_1.Col, null, collapsibleControls))),
        !wide && (react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(StyledPopover, { trigger: ["click"], content: collapsibleControls },
                react_1.default.createElement(ControlBarButton_1.default, { icon: react_1.default.createElement(icons_1.MoreOutlined, null) }))))));
};
exports.default = LeftContent;
var templateObject_1;
